import { useSelector } from 'react-redux';

// Types
import { Workspace } from 'Shared/types/Workspace.type';

// Hooks
import { useCurrentUser } from './use-current-user';

// Helpers
import { formatWorkspaceTitle } from 'Shared/helpers';

export const useWorkspace = () => {
  const { user: currentUser, slug: currentUserSlug } = useCurrentUser();

  const workspace = useSelector((state: { workspace: Workspace }) => state.workspace);
  const { isPersonal, isGroup, isOneOnOne, isTeamSync, users, name, id, loading } = workspace;

  const workspaceTitle = formatWorkspaceTitle({ workspace, user: currentUser });

  const recurringConferenceUrl = workspace.recurringMeeting?.conferenceUrl;

  // only set other user if workspace is a one on one
  const otherUserInOneOnOne = isOneOnOne ? workspace?.users.find(u => u.slug !== currentUserSlug) || null : null;

  const isMeetingModeActive = window.location.pathname.endsWith('/meet');

  return {
    workspace,
    workspaceTitle,
    users,
    name,
    isPersonal,
    isGroup,
    isOneOnOne,
    isTeamSync,
    otherUserInOneOnOne,
    id,
    loading,
    isMeetingModeActive,
    recurringConferenceUrl,
  };
};
